import { each } from "lodash";

import { OptionSerializer } from "serializers";

export const FeedbackOptionSerializer = response => {
  const feedbackOptions = [];

  each(response.questions, question => {
    each(question.options, option => {
      if (option.telemetry) {
        const feedbackOption = OptionSerializer(option);
        feedbackOptions.push(feedbackOption);
      }
      each(option.subOptions, subOption => {
        const feedbackOption = OptionSerializer(subOption);
        feedbackOptions.push(feedbackOption);
      });
    });
  });

  return feedbackOptions;
};
